import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './index.less';

import TablePropTypes from '../../prop-types';

import TableHeadItem from '../TableHeadItem';

function getHeadItems(headers) {
	return headers.reduce((acc, items) => {
		return acc.concat(
			...items.filter((item) => !item.header.colSpan).map((item) => ({
				...item,
				header: {
					...item.header,
					rowSpan: null
				}
			}))
		);
	}, []);
}

function TableHeadItemSticky({ visible, headers, renderTH }) {
	return (
		<TableHeadItem
			className={cn('new-table__head__item-sticky', {
				'new-table__head__item-sticky-visible': visible
			})}
			items={getHeadItems(headers)}
			renderTH={renderTH}
		/>
	);
}

TableHeadItemSticky.propTypes = {
	visible: PropTypes.bool.isRequired,
	headers: TablePropTypes.HeadersPropType,
	renderTH: TablePropTypes.RenderPropType
};

export default TableHeadItemSticky;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/components/TableHeadItemSticky/index.js